import { appRouterPaths } from 'services/navigation';
import { EducationClassesPage } from 'pages/EducationClasses';
import type { AppRouteProps } from '../types';

export const educationClassesPageRoute: AppRouteProps = {
  path: appRouterPaths.educationClasses,
  element: <EducationClassesPage />,
};
